import { useOnUpdate } from '@wyz/utils';
import { isNil } from 'lodash-es';
import { useRef } from 'react';

export function useScrollToNewItem<T>(
  fields: T[],
  type: string,
  idKey: keyof T,
) {
  const isFirstRender = useRef(true);
  useOnUpdate(
    (previousDeps: [T[]]) => {
      const prevLength = previousDeps[0].length;
      if (prevLength < fields.length) {
        if (isFirstRender.current) {
          isFirstRender.current = false;
          return;
        }
        const item = fields[fields.length - 1];
        if (isNil(item)) {
          return;
        }
        const element = document.getElementById(
          `${type}-${String(item[idKey])}`,
        );
        if (
          !isNil(element) &&
          element.getBoundingClientRect().bottom > window.innerHeight
        ) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
    [fields, type, idKey],
  );
}
